import React from "react";
import HeroSection from "../components/HeroSection";
import FeatureCard from "../components/FeatureCard";
import { Link } from "react-router-dom";
import { heroSections, serviceFeatureCards } from "../constants/data.ts";

const Services = () => {
  return (
    <main className="bg-background">
      {/* Hero Section */}
      <HeroSection {...heroSections.services} />

      {/* Services Grid */}
      <section className="py-16 md:py-24 px-outer">
        <div className="container mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {serviceFeatureCards.map((service, index) => (
              <FeatureCard key={index} {...service} />
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 md:py-24 px-outer bg-gradient-to-r from-secondary to-blue-900">
        <div className="container mx-auto text-center text-white">
          <h2 className="font-rubik font-bold text-3xl md:text-4xl mb-4">
            Ready to Get Started?
          </h2>
          <p className="font-rubik font-light text-lg mb-8 max-w-2xl mx-auto">
            Contact our team today to discuss how our services can benefit your
            business.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/contact" className="btn-primary">
              Contact Us
            </Link>
          </div>
        </div>
      </section>
    </main>
  );
};

export default Services;
